import { defineAsyncComponent } from 'vue'
export default {
  landing: defineAsyncComponent(() => import("/app/layers/base/layouts/landing.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/app/layers/auth/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/app/layers/dashboard/layouts/dashboard.vue").then(m => m.default || m))
}